module.exports = "../../static/img/logo.a8cf967.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.png
// module id = 500
// module chunks = 2